module.exports = __webpack_public_path__ + "img/img45.c175af45.png";